// extracted by mini-css-extract-plugin
module.exports = {"BuildControls":"BuildControls_BuildControls__1GJqF","OrderButton":"BuildControls_OrderButton__2SFkd","enable":"BuildControls_enable__27ZQv"};